import {BaseAttribute, BaseAttributeOptions} from './BaseAttribute';

export type IntegerAttributeOptions = BaseAttributeOptions;

// Attribute for whole-number columns
export class IntegerAttribute extends BaseAttribute {
  constructor(options: IntegerAttributeOptions = {}) {
    super(options);
  }

  // Input type that is used if attribute is used in edit mode
  get inputType(): string {
    return 'int';
  }

  getInitialValue(): unknown {
    // If the creation value is set explicitly to SORT_ORDER_NULL_VALUE, we need to use the null value (sort order for example, needs 0 to set value via trigger after insert)
    if (this.creationValue === 'SORT_ORDER_NULL_VALUE') {
      return null;
    }
    return this.creationValue ? this.creationValue : 0;
  }
}
